import { createContext, useContext, useLayoutEffect } from 'react';

type HeaderSetter = (node: JSX.Element | null) => void;

export const FirmMainHeaderSetterContext = createContext(null as HeaderSetter | null);

/** Renders the given node into the firm shell top bar (right of the logo). Call from firm route pages only. */
export function useFirmMainHeaderSlot(content: JSX.Element) {
  const setHeader = useContext(FirmMainHeaderSetterContext);
  useLayoutEffect(() => {
    if (!setHeader) return;
    setHeader(content);
    return () => setHeader(null);
  }, [content, setHeader]);
}
